"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIMPLE_UNISWAP_ORACLE = void 0;
const types_1 = require("../types");
exports.SIMPLE_UNISWAP_ORACLE = {
    [types_1.Networks.Ropsten]: {
        [types_1.Factory.V2V1]: '0xc53bb18028feA1B413057e2b2474F9838c465Fc3'
    },
    [types_1.Networks.Mainnet]: {
        [types_1.Factory.V2V1]: '0x5671B249391cA5E6a8FE28CEb1e85Dc41c12Ba7D'
    },
    [types_1.Networks.Polygon]: {
        [types_1.Factory.V2V1_1]: '0x3271CC175577465691E48196955e09d638Fa05D5',
        [types_1.Factory.V2V2]: '0x3271CC175577465691E48196955e09d638Fa05D5',
    },
    [types_1.Networks.Arbitrum]: {
        [types_1.Factory.V2V1_1]: '0x5671B249391cA5E6a8FE28CEb1e85Dc41c12Ba7D',
        [types_1.Factory.V2V2]: '0x9c7213207b5f8726164c96a76a4b9c0fbf984aba',
    },
    [types_1.Networks.Avalanche]: {
        [types_1.Factory.V2V1_2]: '0xC12E00DE204d58eAd5B5cE9054E94aeE7747fB6C',
        [types_1.Factory.V2V2]: '0x9c7213207b5f8726164c96a76a4b9c0fbf984aba',
    },
    [types_1.Networks.Moonriver]: {
        [types_1.Factory.V2V1_2]: '0x5671B249391cA5E6a8FE28CEb1e85Dc41c12Ba7D'
    },
    [types_1.Networks.Aurora]: {
        [types_1.Factory.V2V1_2]: '0x5671B249391cA5E6a8FE28CEb1e85Dc41c12Ba7D'
    },
    [types_1.Networks.Blast]: {
        [types_1.Factory.V2V2]: '0x0d05ED909d17Ac02B71D083C199f09577eFbe034'
    },
    [types_1.Networks.Cronos]: {},
    [types_1.Networks.Fantom]: {},
    [types_1.Networks.Harmony]: {},
    [types_1.Networks.Moonbeam]: {},
    [types_1.Networks.Sxnetwork]: {},
    [types_1.Networks.Canto]: {},
    [types_1.Networks.ZksyncEra]: {},
    [types_1.Networks.Base]: {
        [types_1.Factory.V2V2]: "0x1fd55593ccD75e5727bb71bEB155e86d7290eAD6"
    },
    [types_1.Networks.Scroll]: {},
    [types_1.Networks.Real]: {},
    [types_1.Networks.Optimism]: {},
    [types_1.Networks.Mantle]: {
        [types_1.Factory.V2V2]: '0x936c30E14daED88fd29bf4FCe2965EbEDe633846'
    },
    [types_1.Networks.Sonic]: {},
    [types_1.Networks.Linea]: {},
};
